import { computed } from 'vue'
import { useRoute, useRuntimeConfig, useHead } from '#app'

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const config = useRuntimeConfig()
  const siteUrl = config.public.siteUrl

  const canonicalUrl = computed(() => `${siteUrl}${route.path}`)

  useHead(computed(() => ({
    link: [
      {
        rel: 'canonical',
        href: canonicalUrl.value
      }
    ]
  })))
})